import queryString from 'query-string';
import api from './api';

const resource = 'User/';

const turnstileConfig = (token) =>
  token ? { headers: { 'X-Turnstile-Token': token } } : {};

export const login = async (body, turnstileToken) => {
  return await api.post(
    resource +
      `Login?${queryString.stringify(body, {
        skipNull: true,
      })}`,
    null,
    turnstileConfig(turnstileToken)
  );
};

export const register = async (body, turnstileToken) => {
  return await api.post(resource + 'Register', body, turnstileConfig(turnstileToken));
};

export const getUserDetail = async () => {
  return await api.get(resource + 'WhoAmI');
};

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const updateProfile = async (body) => {
  return await api.post(resource + 'UpdateProfile', body);
};

export const contact = async (body) => {
  return await api.post(resource + 'Contact', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

export const sendEmailForgotPassword = async (email, turnstileToken) => {
  // A literal "+" in a query string reads back as a space on the server.
  return await api.get(
    resource + 'ForgotPassword?email=' + encodeURIComponent(email),
    turnstileConfig(turnstileToken)
  );
};

export const resetPassword = async (body, turnstileToken) => {
  return await api.post(resource + 'ForgotPassword', body, turnstileConfig(turnstileToken));
};

const userApi = {
  login,
  getUserDetail,
  register,
  list,
  updateProfile,
  upsert,
  deleteById,
  sendEmailForgotPassword,
  resetPassword,
  contact,
};

export default userApi;
